<!-- =========================================================================================
  File Name: UserEditTabSocial.vue
  Description: User Edit Social Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="OpportunityFees" class="data-list-container">
    <vs-prompt
      :title="fee.Id === undefined || fee.Id === 0 ? $t('Add New Fee') : $t('Edit Fee')"
      :accept-text="$t('Save')"
      :cancel-text="$t('Cancel')"
      @cancel="clearFeeModal"
      @accept="saveFee"
      @close="clearFeeModal"
      :is-valid="isFormValid"
      :active.sync="activePrompt"
    >
      <VuePerfectScrollbar style="height: 400px!important" class="scroll-area p-4" :settings="settings">
        <form @submit.prevent>
          <div class="vx-row">
            <div class="vx-col w-full mt-4">
              <vs-input :label="$t('Code')" v-model="fee.FeeCode" class="w-full" name="feeCode" />
            </div>

            <div class="vx-col w-full mt-4">
              <vs-input :label="$t('Fees Name Arabic') + ' *'" v-model="fee.FeeNameAr" class="w-full" name="feeNameAr" />
            </div>

            <div class="vx-col w-full mt-4">
              <vs-input :label="$t('Fees Name English')" v-model="fee.FeeNameEn" class="w-full" name="feeNameEn" />
            </div>

        <div class="vx-col w-full mt-4">
              <label class="vs-input--label">{{ $t('Fees Type') }} *</label>
              <v-select 
                :options="feeTypeOptions" 
                v-model="fee.FeeType" 
                :reduce="option => option.value"
                class="w-full"
              />
            </div>

            <div class="vx-col w-full mt-4">
              <label class="vs-input--label">{{ $t('Calculation Method') }} *</label>
              <v-select 
                :options="calculationMethodOptions" 
                v-model="fee.CalculationMethod" 
                :reduce="option => option.value"
                class="w-full"
              />
            </div>

            <div class="vx-col w-full mt-4">
              <vs-input 
                type="number" 
                :label="$t('Value') + ' *'" 
                v-model="fee.FeeValue" 
                class="w-full" 
                name="feeValue" 
              />
            </div>

            <div class="vx-col w-full mt-4">
              <vs-input :label="$t('Notes')" v-model="fee.Notes" class="w-full" name="notes" />
            </div>
          </div>
        </form>
      </VuePerfectScrollbar>
    </vs-prompt>

    <vx-card class="mb-base" :title="$t('Opportunity Fees Details')">
      <div class="flex flex-wrap items-center justify-between mb-4">
        <vs-button 
          type="border" 
          icon-pack="feather" 
          icon="icon-plus" 
          @click="activePrompt = true"
          :disabled="!opportunity.Id || opportunity.Id <= 0"
        >
          {{ $t('Add Fee') }}
        </vs-button>
      </div>

      <vs-table :data="feesList">
        <template slot="thead">
          <vs-th>{{ $t('Code') }}</vs-th>
          <vs-th>{{ $t('Name') }}</vs-th>
          <vs-th>{{ $t('Type') }}</vs-th>
          <vs-th>{{ $t('Method') }}</vs-th>
          <vs-th>{{ $t('Value') }}</vs-th>
          <vs-th>{{ $t('Action') }}</vs-th>
        </template>

       <template slot-scope="{data}">
        <tbody>
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ tr.FeeCode }}</vs-td>
            
            <vs-td>{{ currentLocale === 'ar' ? tr.FeeNameAr : tr.FeeNameEn }}</vs-td>
            
            <vs-td>{{ $t(tr.FeeType) }}</vs-td>
            
            <vs-td>{{ $t(tr.CalculationMethod) }}</vs-td>
            
            <vs-td>
              <span>
                {{ tr.FeeValue }} 
                {{ tr.CalculationMethod === 'Percentage' ? '%' : $t('SAR') }}
              </span>
            </vs-td>

            <vs-td>
              <div class="flex items-center">
                <feather-icon 
                  icon="EditIcon" 
                  svgClasses="w-5 h-5 hover:text-primary cursor-pointer" 
                  @click.stop="editFee(tr)" 
                />
                <feather-icon 
                  icon="TrashIcon" 
                  svgClasses="w-5 h-5 hover:text-danger cursor-pointer" 
                  class="ml-2" 
                  @click="openConfirm(tr)" 
                />
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: { vSelect, VuePerfectScrollbar },
  props: {
    opportunity: { type: Object, required: true }
  },
  data() {
    return {
      activePrompt: false,
      fee: {
        Id: 0,
        OpportunityId: null,
        FeeCode: '',
        FeeNameAr: '',
        FeeNameEn: '',
        FeeType: '',
        CalculationMethod: '',
        FeeValue: 0,
        IsRequired: true,
        Notes: '',
        IsActive: true
      },
      settings: { maxScrollbarLength: 60, wheelSpeed: 0.30 }
    }
  },
  computed: {

    feeTypeOptions() {
    return [
      { label: this.$t('Buyer'), value: 'Buyer' },
      { label: this.$t('Platform'), value: 'Platform' },
      { label: this.$t('Seller'), value: 'Seller' }
    ]
  },
  

  calculationMethodOptions() {
    return [
      { label: this.$t('Percentage'), value: 'Percentage' },
      { label: this.$t('Fixed'), value: 'Fixed' }
    ]
  },
    currentLocale() { return this.$i18n.locale; },
    feesList() { return this.$store.state.OpportunitiesList.OpportunityFees; },
    isFormValid() {
  
      return this.fee.FeeNameAr && this.fee.FeeType && this.fee.CalculationMethod && this.fee.FeeValue > 0;
    }
  },
  methods: {
   saveFee() {
 
  this.fee.OpportunityId = this.opportunity.Id;
  const action = (this.fee.Id && this.fee.Id > 0) ? "updateFee" : "addFee";
  
  this.$vs.loading();
  this.$store.dispatch(`OpportunitiesList/${action}`, this.fee)
    .then(() => {
      this.$vs.loading.close();
      this.clearFeeModal();
      
      this.$vs.notify({ 
        title: 'Success', 
        text: 'Saved Successfully', 
        color: 'success' 
      });
    })
    .catch(err => {
      this.$vs.loading.close();
      const msg = (err.response && err.response.data && err.response.data.Message) 
                  ? err.response.data.Message 
                  : err.message;
                  
      this.$vs.notify({ 
        title: 'Error', 
        text: msg, 
        color: 'danger' 
      });
    });
},
    editFee(data) {
      this.fee = JSON.parse(JSON.stringify(data));
      this.activePrompt = true;
    },
    clearFeeModal() {
      this.fee = { 
        Id: 0, FeeCode: '', FeeNameAr: '', FeeNameEn: '', 
        FeeType: '', CalculationMethod: '', FeeValue: 0, 
        IsRequired: true, Notes: '', IsActive: true, 
        OpportunityId: this.opportunity.Id 
      };
      this.activePrompt = false;
    },
    openConfirm(data) {
      this.rowDataForDelete = data;
      this.$vs.dialog({
        type: "confirm", color: "danger", title: this.$t("Confirm Delete"),
        text: this.$t("Are you sure?"), accept: this.acceptDelete
      });
    },
    acceptDelete() {
      this.$store.dispatch("OpportunitiesList/deleteFee", this.rowDataForDelete.Id)
        .then(() => {
          this.$store.dispatch("OpportunitiesList/fetchOpportunityFees", this.opportunity.Id);
        });
    }
  },
  created() {
    if (this.opportunity.Id) {
      this.$store.dispatch("OpportunitiesList/fetchOpportunityFees", this.opportunity.Id);
    }
  }
}
</script>

<style lang="scss">
 .icon-container{
    display: flex;
  }
</style>
